import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export function ProtectedRoute() {
  const { state } = useAuth();

  // While the session is being restored (silent refresh on mount), show a spinner.
  if (state.status === 'loading') {
    return (
      <div className="min-h-dvh flex items-center justify-center bg-slate-50">
        <div className="w-8 h-8 border-2 border-brand-rose/30 border-t-brand-rose rounded-full animate-spin" />
      </div>
    );
  }

  if (state.status !== 'authenticated') {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
